export default "/_next/static/fonts/tt_norms_pro_thin-b94d4c9ee0f930c900fbbb64e511b935.woff";